import { render } from "./SvgModule.vue?vue&type=template&id=575bd5a4"
import script from "./SvgModule.vue?vue&type=script&lang=js"
export * from "./SvgModule.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__